import { Tabs } from '@mantine/core'
import { useRecoilState } from 'recoil'

import classes from '../assets/css/components/TabMenu.module.css'
import CheckInStampAnalysis from '../pages/checkin-stamp/CheckInStampAnalysis'
import Info from '../pages/common/Info'
import UserVisitAnalysis from '../pages/user-visit/UserVisitAnalysis'
import { ActiveTabKeyAtom } from '../recoil/atoms'

function TabMenu() {
  const [activeTabKey, setActiveTabKey] = useRecoilState(ActiveTabKeyAtom)

  const handleTabChange = (newTabKey: string | null) => {
    setActiveTabKey(newTabKey)
  }

  return (
    <Tabs
      variant="outline"
      color='#001E61'
      value={activeTabKey}
      onChange={handleTabChange}
      classNames={classes}
    >
      <Tabs.List>
        <Tabs.Tab value="info">
          お知らせ
        </Tabs.Tab>
        <Tabs.Tab value='appuser-visit'>
          アプリユーザー来訪・店内通知分析
        </Tabs.Tab>
        {/* <Tabs.Tab value='check-in-stamp'>
            チェックインスタンプ分析
        </Tabs.Tab> */}
      </Tabs.List>

      <Tabs.Panel value="info">
        <Info />
      </Tabs.Panel>

      <Tabs.Panel value="appuser-visit">
        <UserVisitAnalysis />
      </Tabs.Panel>

      <Tabs.Panel value="check-in-stamp">
        <CheckInStampAnalysis />
      </Tabs.Panel>
    </Tabs>
  )
}

export default TabMenu
